"use client";

import React from "react";

export default function infoTorneo({ torneo, onChange }) {
  return (
    <div>
      <div className="section-title">Detalles del Torneo</div>
      <div className="card">
        <div className="card-body">
          <div className="row">
            <div className="col-md-8">
              <div className="form-group">
                <label htmlFor="nombreTorneo" className="font-weight-bold" style={{ fontSize: "0.875rem" }}>
                  Nombre del Torneo
                </label>
                <input
                  type="text"
                  className="form-control form-control-lg"
                  id="nombreTorneo"
                  placeholder="Ingrese Nombre del Torneo..."
                  value={torneo.nombre}
                  onChange={(e) => onChange({ ...torneo, nombre: e.target.value })}
                />
              </div>
            </div>
            <div className="col-md-4">
              <div className="form-group">
                <label htmlFor="anoTorneo" className="font-weight-bold" style={{ fontSize: "0.875rem" }}>
                  Año
                </label>
                <input
                  type="number"
                  className="form-control form-control-lg"
                  id="anoTorneo"
                  placeholder="Año"
                  value={torneo.ano}
                  onChange={(e) =>
                    onChange({
                      ...torneo,
                      ano: parseInt(e.target.value) || "",
                    })
                  }
                  min={2000}
                  max={2100}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
